
/*!
 * SwGridSystem - v0.0.1 - 2019-02-01
 * github: necmi
 */

const SwGridSystem = function (_target) {
    if (!(this instanceof SwGridSystem)) return new SwGridSystem(_target)

    this.gridKey = "Grid";

    this.expiredDay = 7;

    this.body = document.querySelector("body");

    if (typeof document.getElementsByName(_target)[0] != 'undefined') {
        this.target = document.querySelector(_target);
    }
    
    this.grid = 4;
}

SwGridSystem.prototype.init = function () {
    this.setGridValue();
    var gridVal = this.getCookie(this.gridKey);
    if (gridVal != null && gridVal != undefined) {
        this.grid = gridVal;
    }

    this.$target.addEventListener("change", function () {
        this.setGridValue();
    });

}

SwGridSystem.prototype.setGridValue = function () {
    var gridVal = this.$target.value;
    if (gridVal != null && gridVal != undefined) {
        this.setCookie(this.gridKey, gridVal, this.expiredDay);
    }
}

SwGridSystem.prototype.setCookie = function(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

SwGridSystem.prototype.getCookie = function(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

SwGridSystem.prototype.eraseCookie = function(name) {
    document.cookie = name + '=; Max-Age=-99999999;';
}
